import type { LazyBlockVM, NotLazyBlockVM } from '../block.vm';

export const TOP_ARTICLES_BLOCK_TYPE_VM = 'top_news';

export type TopArticlesLazyBlockVM = LazyBlockVM<typeof TOP_ARTICLES_BLOCK_TYPE_VM>;

export type TopArticleStatisticVM = {
  views?: {
    count: string;
  };
  comments?: {
    link: string;
    text: string;
  };
};

export type TopArticleVM = {
  id: number;
  header: {
    link: string;
    text: string;
  };
  statistic: TopArticleStatisticVM;
};

export type TopArticlesBlockDataVM = TopArticleVM[];

export type TopArticlesBlockParamsVM = {
  title: string;
};

export type TopArticlesNotLazyBlockVM = NotLazyBlockVM<
  typeof TOP_ARTICLES_BLOCK_TYPE_VM,
  TopArticlesBlockDataVM,
  TopArticlesBlockParamsVM,
  null
>;

export type TopArticlesBlockVM = TopArticlesLazyBlockVM | TopArticlesNotLazyBlockVM;

export const guardTopArticlesBlockNotLazy = (
  block: TopArticlesBlockVM,
): block is TopArticlesNotLazyBlockVM => !block.isLazy;
